export function QKeyboardTarget() {
  this.fKeyboardTargetElement = null;
  this.fKeyboardTargetPanel = null;
}
